import { componentsScope } from "../../../common/utils/logger.js";

export const dialogScope = /*           */ componentsScope.scope("focused-dialog-v1");

export const getFirstAvailableParam = (
  keys: string[],
  defaultValue: string | undefined,
  params = new URLSearchParams(location.search),
): string | undefined => {
  for (const key of keys) {
    const value = params.get(key) ?? undefined;
    if (typeof value === "string") return value;
  }
  return defaultValue;
};

export function isSafeUrl(
  url: string,
  { host: currentHost, protocol: currentProtocol } = location,
): boolean {
  try {
    /*                                     */
    const { host, protocol, pathname } = new URL(url, window.location.href);

    /*                                                                             */
    if (/\/{2,}/g.test(pathname)) {
      return false;
    }

    const isSafe = host === currentHost && protocol === currentProtocol;

    if (!isSafe) {
      dialogScope.warn("is not safe", url);
    }
    return isSafe;
    /*                                                         */
  } catch (e) {
    dialogScope.warn(e);
    return false;
  }
}

export const prefix = "oc-focused-dialog-v1";
export const closeParam = `${prefix}.close-url`;
export const prevParam = `${prefix}.prev-url`;
